import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_HOUSEHOLD_GET_BY_APPLICATION_ID } from 'api/actionTypes';

export default async function loadByApplicationId({ state, apiClient }, { applicationId }) {
  typeCheck('applicationId::PositiveNumber', applicationId);
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_GET_BY_APPLICATION_ID,
    queryId: String(applicationId),
    state: state,
    payload: {
      applicationId: applicationId,
    },
    onSuccess(household) {
      state.set(['household', 'byId', household.id], household);
    },
  });
}
